import http from './http';

export type TagOverviewTag = {
  id: number;
  title: string;
  color: string;
  sheet: number;
  node_count: number;
};

export type TagOverviewEdge = {
  source_tag_id: number;
  target_tag_id: number;
};

export type TagOverviewResponse = {
  tags: TagOverviewTag[];
  edges: TagOverviewEdge[];
};

export const tagOverviewApi = {
  async get(sheetId: number): Promise<TagOverviewResponse> {
    const res = await http.get(`/v1/tag/overview/${sheetId}`);
    return res.data as TagOverviewResponse;
  },
};

export default tagOverviewApi;
